import styled from 'styled-components';

import { metrics } from '../../assets/styles/commonStyle';

export const ImageList = styled.div`
  display: flex;
`;
export const ImageItem = styled.div`
  height: 80px;
  width: 150px;
  overflow: hidden;
  align-self: center;
  margin-right: ${metrics.margin.base}px;
  &:last-child {
    margin-right: 0;
  }

  cursor: pointer;
  position: relative;
  img {
    width: 150px;
    z-index: 1;
    position: relative;
    object-fit: contain;
    height: 80px;
  }

  :after {
    background: #e1e1e1;
    position: absolute;
    height: 70px;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    font-weight: 300;
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 12px;
    z-index: 0;
    color: #555;
    padding: ${metrics.padding.base}px;
  }
`;
